import TemplateView from '../../TemplateView'
import UserInitialsIcon from '../../components/UserInitialsIcon'
import UserNameFormat from '../../util/UserNameFormat'
import {DateFormat} from '../../date_format'
import messageResource from '../../messageResource'
import EditCommentInput from "./EditCommentInput"
import Button from '../../components/Button'
import $ from 'jquery'
import SimpleTooltip from '../../SimpleTooltip'
import LoadingContainer from '../../util/LoadingContainer'
import linkifyString from 'linkifyjs/string'

export default class CommentRow extends TemplateView {
    constructor({
        id,
        userInfo,
        color = '',
        onCommentEditStart = () => {},
        onCommentSave = () => {},
        onCancelEdit = () => {},
        onEditingTextChanged = () => {},
        onDeleteIconClickCb = () => {},
        onCommentDeleted = () => {},
        refreshScrollCb = () => {},
    }) {
        super()

        this.params = {
            id,
            userInfo,
            color
        }

        this.callbacks = {
            onCommentEditStart,
            onCommentSave,
            onCancelEdit,
            onEditingTextChanged,
            onDeleteIconClickCb,
            onCommentDeleted,
            refreshScrollCb,
        }

        this.state = {
            creationTimestamp: null,
            updatingUser: null,
            updatingTimestamp: null,
            text: '',
            recentlyAdded: false,
            inEdit: false,
            editingText: '',
            canEdit: false,
            updating: false,
        }

        this.onStatePropertyChanged('creationTimestamp', creationTimestamp => {
            const timeLabel = new DateFormat(window.SystemSettings.dateFormat, window.SystemSettings.clockFormat).formatDateTime(Date.parseJSONTimeWithoutTimeZone(creationTimestamp));
            this.$creationTimestamp.text(timeLabel)
        })

        this.onStatePropertyChanged('updatingUser', () => this._updateEditedInfo())

        this.onStatePropertyChanged('text', text => {
            this.$text.html(linkifyString(text))
        })

        this.onStatePropertyChanged('recentlyAdded', recentlyAdded => this.$el.toggleClass('new', recentlyAdded))

        this.onStatePropertyChanged('inEdit', () => this._toggleEditInput())
        this.onStatePropertyChanged('editingText', editingText => this.editCommentInput.setState({text: editingText}))

        this.onStatePropertyChanged('canEdit', canEdit => this.getEl().toggleClass('canEdit', canEdit))

        this.onStatePropertyChanged('updating', updating => this.editCommentInputWrapper.setState({loading: updating}))
    }

    templateHtml() {
        return "<div class='commentRow'>" +
               "    <div class='userInitialsIconPlaceholder'></div>" +
               "    <div class='rightContainer'>" +
               "        <div class='commentHeader'>" +
               "            <div class='info'>" +
               "                <div class='username'><%-username%></div>" +
               "                <div class='creationTimestamp'/>" +
               "                <div class='updatingInfo'></div>" +
               "            </div>" +
               "            <div class='buttonsContainer'>" +
               "                <div class='editButton'/>" +
               "                <div class='separator'/>" +
               "                <div class='deleteButton'/>" +
               "            </div>" +
               "        </div>" +
               "        <div class='deleteConfirmationContainer'>" +
               "            <div class='deleteConfirmationTitle'><%=deleteConfirmationTitle%></div>" +
               "            <div class='deleteConfirmationButtons'/>" +
               "        </div>" +
               "        <div class='text'/>" +
               "        <div class='editCommentInputPlaceholder'/>" +
               "    </div>" +
               "</div>";
    }

    messageKeys() {
        return {
            deleteConfirmationTitle: 'panel.common.comments.delete_confirmation_title',
        }
    }

    templateModel() {
        return {
            username: this._getUserName(this.params.userInfo)
        }
    }

    afterRender() {
        new UserInitialsIcon({
            firstName: this.params.userInfo.firstName,
            lastName: this.params.userInfo.lastName,
            color: this.params.color
        }).init(this.find('.userInitialsIconPlaceholder'))

        this.$commentHeader = this.find('.commentHeader')
        this.$buttonsContainer = this.find('.buttonsContainer')
        this.$deleteConfirmationContainer = this.find('.deleteConfirmationContainer')

        this.$creationTimestamp = this.find('.creationTimestamp')
        this.$updatingInfo = this.find('.updatingInfo')

        this.find('.deleteButton').click(() => this._handleDeleteBtnClick())

        this.find('.editButton').click(() => {
            if (this.state.canEdit) this.callbacks.onCommentEditStart(this.params.id)
        })

        this.$text = this.find('.text')
        this.$editCommentInputPlaceholder = this.find('.editCommentInputPlaceholder')

        this.$deleteConfirmationContainer.hide()
    }

    _getUserName(userInfo) {
        return UserNameFormat.formatFML(userInfo.firstName, userInfo.lastName, userInfo.middleName)
    }

    _toggleEditInput() {
        this.$text.toggle(!this.state.inEdit)

        if (this.state.inEdit) {
            this.editCommentInput = new EditCommentInput({
                onCommentEditedCb: (text) => this._handleSaveChangesClick(text),
                onCancelCb: this.callbacks.onCancelEdit,
                onEditingTextChanged: this.callbacks.onEditingTextChanged,
                refreshScrollCb: this.callbacks.refreshScrollCb,
            })
            this.editCommentInput.setState({text: this.state.text})

            this.editCommentInputWrapper = new LoadingContainer({
                contentComponent: this.editCommentInput,
                containerClass: 'editCommentInputLoadingWrapper',
            }).init(this.$editCommentInputPlaceholder)

        } else {
            this.$editCommentInputPlaceholder.empty()
            delete this.editCommentInput
        }

        this.callbacks.refreshScrollCb()
    }

    _toggleDeleteConfirmation(show) {
        this.getEl().toggleClass('confirmDelete', show)
        this.$deleteConfirmationContainer.toggle(show)
        this.$commentHeader.toggle(!show)

        if (show) {
            this.$deleteConfirmationButtons = this.find('.deleteConfirmationButtons')

            new Button({
                additionalClass: 'confirmDeleteBtn',
                label: messageResource.getMessage('panel.common.comments.delete_confirmation_button_text'),
                onClickCb: () => this.callbacks.onCommentDeleted(this.params.id)
            }).init(this.$deleteConfirmationButtons)

            new Button({
                additionalClass: 'cancelBtn',
                label: messageResource.getMessage('common.cancel'),
                onClickCb: () => {
                    this._toggleDeleteConfirmation(false)
                }
            }).init(this.$deleteConfirmationButtons)
        } else {
            this.$deleteConfirmationButtons.empty()
        }
    }

    _updateEditedInfo() {
        if (this.state.updatingUser) {
            const timeLabel = new DateFormat(window.SystemSettings.dateFormat, window.SystemSettings.clockFormat).formatDateTime(Date.parseJSONTimeWithoutTimeZone(this.state.updatingTimestamp));

            this.$updatingInfo
                .text(messageResource.getMessage('panel.common.comments.edited', [timeLabel]))
                .show()

            const tooltip = getTooltip()
            tooltip.subscribeToMouseEvents(this.$updatingInfo, () => {
                const username = this._getUserName(this.state.updatingUser)
                tooltip.setText(messageResource.getMessage('panel.common.comments.edited_by_text', [username, timeLabel]))
            })
        }
    }

    _handleSaveChangesClick(text) {
        if (this.state.text !== text) {
            this.callbacks.onCommentSave()
        } else {
            this.callbacks.onCancelEdit()
        }
    }

    _handleDeleteBtnClick() {
        if (this.state.canEdit) {
            this.callbacks.onDeleteIconClickCb(this.params.id)
            if (this.state.inEdit) {
                this.callbacks.onCancelEdit()
            }
            this._toggleDeleteConfirmation(true)
        }
    }

    static getTooltip() {
        return getTooltip()
    }
}

let tooltip

const getTooltip = () => {
    if (!tooltip)
        tooltip = new SimpleTooltip({
            extraClass: 'commentEditedByTooltip',
        }).init($('body'))
    return tooltip
}


// WEBPACK FOOTER //
// ./web/js/panels/comments/CommentRow.js